import EmptyGiftCard from "@/assets/images/empty-giftcard.png";
import { Typography } from "@/components/shared/typography";
import { Image, View } from "@/components/ui";

export const GiftCardHistoryEmpty = () => {
  return (
    <View className="py-6">
      <View className="flex flex-col items-center gap-2">
        <Image
          src={EmptyGiftCard}
          width={140}
          height={140}
          className="size-[140px] object-contain"
        />
        <Typography variant="label-sm" color="foreground-default">
          No gift history yet
        </Typography>
        <Typography variant="body-sm" color="foreground-intermediate" className="text-center">
          Your sent and received gift cards will appear here.
        </Typography>
      </View>
    </View>
  );
};
